export enum QuickCardValue {
  FIVE = '5',
  TEN = '10',
  FIFTEEN = '15'
}
